import { Input } from '@healthinal/ui';
import { useState } from 'react';

import type { IBezugspersonWithPerson } from '../../../../api/generated/bezugperson-controller/bezugperson-controller';
import { CreateReferencePersonDialog } from '../../../../components/bezugsperson/CreateReferencePersonDialog';
import { MasterdataTable } from '../MasterTable';
import { ReferencePersonHistoryModal } from './ReferencePersonHistoryModal';
import { ReferencePersonTableRow } from './ReferencePersonTableRow';
import { useReferencePersonTable } from './useReferencePersonTable';

function ReferencePersonTableHeader() {
  return (
    <>
      <th style={{ width: 80 }}>Anrede</th>
      <th style={{ width: 140 }}>Name</th>
      <th style={{ width: 140 }}>Vorname</th>
      <th style={{ width: 160 }}>Funktion</th>
      <th style={{ width: 150 }}>Telefon Nr.</th>
      <th style={{ width: 220 }}>E-Mail</th>
      <th style={{ width: 200 }}>Person</th>
      <th style={{ width: 100 }}>Verlauf</th>
    </>
  );
}

type ReferencePersonDialogState = {
  open: boolean;
  personId: string | null;
  referencePersonId: string | null;
};

type HistoryModalState = {
  open: boolean;
  item: IBezugspersonWithPerson | null;
};

const CLOSED_DIALOG_STATE: ReferencePersonDialogState = {
  open: false,
  personId: null,
  referencePersonId: null,
};

export function ReferencePersonTable() {
  const { items, isLoading, page, totalPages, search, setSearch, setPage } = useReferencePersonTable();
  const [dialogState, setDialogState] = useState<ReferencePersonDialogState>(CLOSED_DIALOG_STATE);
  const [historyModalState, setHistoryModalState] = useState<HistoryModalState>({ open: false, item: null });

  return (
    <>
      <MasterdataTable
        title="Bezugspersonen"
        headerActions={
          <Input
            placeholder="Suche..."
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            sx={{
              width: 260,
              maxWidth: '100%',
              flexShrink: 0,
            }}
          />
        }
        isLoading={isLoading}
        isEmpty={items.length === 0}
        emptyText="Keine Daten vorhanden."
        colSpan={8}
        page={page}
        totalPages={totalPages}
        onPrevPage={() => setPage((prev) => Math.max(0, prev - 1))}
        onNextPage={() => setPage((prev) => Math.min(Math.max(0, totalPages - 1), prev + 1))}
        disablePrev={page === 0 || isLoading}
        disableNext={page + 1 >= totalPages || isLoading}
        header={<ReferencePersonTableHeader />}>
        {items.map((item) => (
          <tr
            key={item.id}
            style={{ textAlign: 'left', cursor: 'pointer' }}
            onClick={() =>
              setDialogState({
                open: true,
                personId: item.person.id,
                referencePersonId: item.id,
              })
            }>
            <ReferencePersonTableRow
              item={item}
              onShowHistory={(selectedItem) => setHistoryModalState({ open: true, item: selectedItem })}
            />
          </tr>
        ))}
      </MasterdataTable>

      {dialogState.personId && dialogState.referencePersonId ? (
        <CreateReferencePersonDialog
          mode="update"
          open={dialogState.open}
          personId={dialogState.personId}
          referencePersonId={dialogState.referencePersonId}
          onClose={() => setDialogState(CLOSED_DIALOG_STATE)}
        />
      ) : null}

      <ReferencePersonHistoryModal
        open={historyModalState.open}
        onClose={() => setHistoryModalState({ open: false, item: null })}
        item={historyModalState.item}
      />
    </>
  );
}
